// Generated by ReScript, PLEASE EDIT WITH CARE

function makeShareable(url, text, param) {
  return {
    url: url,
    text: text
  };
}
function isSupported(param) {
  return window.navigator.share !== undefined;
}
function share(shareable) {
  if (window.navigator.share !== undefined) {
    return window.navigator.share(shareable);
  }
}
export { makeShareable, isSupported, share };
/* No side effect */